import { render } from "./Person.vue?vue&type=template&id=4efd0d6a"
import script from "./Person.vue?vue&type=script&lang=js"
export * from "./Person.vue?vue&type=script&lang=js"

import "./Person.vue?vue&type=style&index=0&id=4efd0d6a&lang=css"

import exportComponent from "D:\\wuliu\\wuliu_vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__